$(document).ready(function() {
  
  // Store info
  let storeFeatures = $('.store-features');
  if(storeFeatures) {
    let wraps = $('.store-features .inner-wrap');
    loopstoreFeaturesWrap(wraps);
    
    addEventListener('resize',function() {
      loopstoreFeaturesWrap(wraps);
    });
    
    function loopstoreFeaturesWrap(wraps) {
      if(window.innerWidth > 768) {
          for(let i = 0; i < (wraps.length - 1); i++) {
            $(wraps[i]).css('borderRight','1px solid');
          }
        } else {
          for(let i = 0; i < (wraps.length - 1); i++) {
            $(wraps[i]).css('borderRight','none');
          }
        }
    }

    $('.store-info').slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
  }
  
  $('.product-single__thumbnails .product-single__thumbnail').each(function(k, img) {
    $(img).click(function() {
      $('#FeaturedImageZoom-product-template').slick('slickGoTo', k);
      return false;
    });
  });
  
  $('#FeaturedImageZoom-product-template').on('afterChange', function(event, slick, currentSlide) { 
     $('.zoomImg').prop('src', $('#FeaturedImageZoom-product-template .product-single__photo').eq(currentSlide).find('img').data('zoom'));
  });
  
});